export default __webpack_public_path__ + "static/media/howtouse_basic_05_01_ko.b55032ca.png";